


export class CostReviewTerminalControllers {
  controllerType!: number[];
  numberOfTerminalUnits!: number;
  numberOfVavs!: number;
  manufacturerVavs!: string;
  customApplicationsRequired!: number;
  vavsInstalledBy!: number;
  numberOfFcus!: number;
  manufacturerFcus!: string;
  fcusInstalledBy!: number;
  numberOfUvs!: number;
  manufacturerUvs!: string;
  unitsControlsFurnishedBy!: number;
  unitsControlsInstalledBy!: number;
  unitsControlsWiredBy!: number;
  driversBoilers!: number;
  power!: number;
  installingPneumaticTubing!: number;
  isTerminalControllersApplicable!: boolean;
}
